<div class="l-core-contents" [ngStyle]="{ position: !isSp ? 'relative' : '' }" #modalContents>
  <!-- [スライダー想定エリア]-->
  <asw-common-slider id="fare-panel-select-slider">
    <button
      id="fare-panel-scroll-left-btn"
      class="l-carousel01__arrow l-carousel01__arrow--prev is-available"
      [attr.aria-label]="'alt.switchToLeftScreen1' | staticMsg"
      *ngIf="isScrollLeft"
      (throttleClick$)="this.scrollToLeft()"
      aswThrottleClick
    >
      <img
        src="assets/images/btn_arrow_prev_36.svg"
        width="36"
        height="36"
        alt="{{ 'alt.switchToLeftScreen1' | staticMsg }}"
        aria-hidden="true"
      />
    </button>
    <div class="l-section u-mt-tb-16 u-mt-sp-8">
      <div style="overflow-x: hidden; max-width: 1366px; margin: 0 auto">
        <!-- FF一覧表示処理 start -->
        <div class="p-fare-panel02" #scrollPanel>
          <ng-container *ngFor="let fareFamily of fareFamilies; index as fareFamilyIndex">
            <div
              id="fare{{ fareFamilyIndex }}"
              class="p-fare-panel02__item"
              style="transition: 0.3s"
              [ngClass]="{
                'p-fare-panel02__item--eco': isEco[fareFamilyIndex],
                'p-fare-panel02__item--ecoPremium': isEcoPremium[fareFamilyIndex],
                'p-fare-panel02__item--business': isBusiness[fareFamilyIndex],
                'p-fare-panel02__item--first': isFirst[fareFamilyIndex],
                'p-fare-panel02__item--disabled': fareFamily?.isAllSoldOut,
                'p-fare-panel02__item--select': isSelect[fareFamilyIndex]
              }"
              role="group"
              [attr.aria-label]="fareFamilyIndex"
              #scrollItemList
            >
              <div class="p-fare-panel02__promotion">
                <span *ngIf="fareFamily.isPromotionApplied" class="c-promotion-applied"
                  ><img
                    class="c-promotion-applied__img"
                    src="assets/images/icon_promotion_applied_20.svg"
                    width="20"
                    height="20"
                    alt="{{ 'label.promotionApplied' | staticMsg }}"
                /></span>
              </div>
              <div class="p-fare-panel02__head js-fix-height-1" style="height: 133px">
                <div class="p-fare-panel02__head-item p-fare-panel02__head-class">
                  <p class="p-fare-panel02__head-item-class">
                    {{ cabinClassList?.[fareFamilyIndex] ?? '' }}
                  </p>
                  <ng-container *ngIf="isFamilyCodeUrlList[fareFamilyIndex] && fareFamilyCodeList[fareFamilyIndex]">
                    <a
                      href="{{ familyCodeUrlList[fareFamilyIndex] | metaUrl }}"
                      id="fare-family-name-url-{{ fareFamilyIndex }}"
                      class="c-text-link-color-primary"
                      target="_blank"
                      ><p class="p-fare-panel02__head-item-rank-url">
                        {{ fareFamilyCodeList[fareFamilyIndex] | staticMsg
                        }}<img
                          class="c-text-link-external"
                          src="assets/images/icon_external_primary_20.svg"
                          width="20"
                          height="20"
                          alt="{{ 'alt.openLinkInNewTab' | staticMsg }}"
                        /></p
                    ></a>
                  </ng-container>
                  <ng-container *ngIf="!isFamilyCodeUrlList[fareFamilyIndex] && fareFamilyCodeList[fareFamilyIndex]">
                    <p class="p-fare-panel02__head-item-rank">{{ fareFamilyCodeList[fareFamilyIndex] | staticMsg }}</p>
                  </ng-container>
                </div>
                <ng-container *ngIf="!fareFamily.isAllSoldOut; else unavailable">
                  <div class="p-fare-panel02__head-item p-fare-panel02__head-price">
                    <div class="p-fare-panel02__head-price-item">
                      <p class="p-fare-panel02__head-item-fare">
                        <span
                          class="p-fare-panel02__head-item-fare-price"
                          [innerHTML]="fareFamily.airOffers?.[0]?.prices?.totalPrice?.total ?? 0 | amountFormat : 'availability.complex_totalPrice' : fareFamily.airOffers?.[0]?.prices?.totalPrice?.currencyCode"
                        ></span>
                      </p>
                      <ng-container *ngIf="fareFamily.isPromotionApplied">
                        <p class="p-fare-panel02__head-item-correction">
                          <span class="u-visually-hidden" [innerHTML]="'heading.beforeChange' | staticMsg"></span>
                          <del
                            ><span
                              class="p-fare-panel02__head-item-correction-price"
                              [innerHTML]="(fareFamily.airOffers?.[0]?.prices?.totalPrice?.discount?.originalTotal || 0)  | amountFormat: 'availability.complex_beforePrice' : fareFamily.airOffers?.[0]?.prices?.totalPrice?.currencyCode"
                            ></span
                          ></del>
                        </p>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
                <ng-template #unavailable>
                  <div class="p-fare-panel02__head-item">
                    <span class="p-fare-panel02__head-item-not-available">{{
                      'm_static_message-label.noVacancy1' | staticMsg
                    }}</span>
                  </div>
                </ng-template>
              </div>
              <ng-container *ngIf="!fareFamily.isAllSoldOut">
                <div class="p-fare-panel02__body js-fix-height-2">
                  <div class="p-fare-panel02__body-item js-fix-height-3">
                    <ul class="c-available-list">
                      <!-- 予約変更可否出し分け start -->
                      <li class="c-available-list__item">
                        <ng-container *ngIf="fareFamily.changeConditionsType === 'unavailable'">
                          <div class="c-available-list__item-icon">
                            <img src="assets/images/icon_feature_not_available_24.svg" width="24" height="24" />
                          </div>
                          <div class="c-available-list__item-title p-fare-panel02__body-item-color-gray">
                            {{ 'm_static_message-label.itineraryNotPermitted' | staticMsg }}
                          </div>
                        </ng-container>
                        <ng-container *ngIf="fareFamily.changeConditionsType === 'withPenalty'">
                          <div class="c-available-list__item-icon">
                            <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
                          </div>
                          <div class="c-available-list__item-title">
                            {{ 'm_static_message-label.itineraryPermittedWithFee' | staticMsg }}
                          </div>
                        </ng-container>
                        <ng-container *ngIf="fareFamily.changeConditionsType === 'free'">
                          <div class="c-available-list__item-icon">
                            <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
                          </div>
                          <div class="c-available-list__item-title">
                            {{ 'm_static_message-label.itineraryPermitted' | staticMsg }}
                          </div>
                        </ng-container>
                      </li>
                      <!-- 予約変更可否出し分け end -->
                      <!-- 払戻可否出し分け start -->
                      <li class="c-available-list__item">
                        <ng-container *ngIf="fareFamily.refundConditionsType === 'unavailable'">
                          <div class="c-available-list__item-icon">
                            <img src="assets/images/icon_feature_not_available_24.svg" width="24" height="24" />
                          </div>
                          <div class="c-available-list__item-title p-fare-panel02__body-item-color-gray">
                            {{ 'm_static_message-label.refundNotPermitted' | staticMsg }}
                          </div>
                        </ng-container>
                        <ng-container *ngIf="fareFamily.refundConditionsType === 'withPenalty'">
                          <div class="c-available-list__item-icon">
                            <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
                          </div>
                          <div class="c-available-list__item-title">
                            {{ 'm_static_message-label.refundPermittedWithFee' | staticMsg }}
                          </div>
                        </ng-container>
                        <ng-container *ngIf="fareFamily.refundConditionsType === 'free'">
                          <div class="c-available-list__item-icon">
                            <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
                          </div>
                          <div class="c-available-list__item-title">
                            {{ 'm_static_message-label.refundPermitted' | staticMsg }}
                          </div>
                        </ng-container>
                      </li>
                      <!-- 払戻可否出し分け end -->
                      <!-- 最小無料預け入れ手荷物個数出し分け start -->
                      <li class="c-available-list__item">
                        <ng-container
                          *ngIf="
                            fareFamily.minFreeCheckedBaggageQuantity && fareFamily.minFreeCheckedBaggageQuantity !== 0
                          "
                        >
                          <div class="c-available-list__item-icon">
                            <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
                          </div>
                          <div class="c-available-list__item-title">
                            {{
                              'm_static_message-label.freeBaggagePcs'
                                | staticMsg : { '0': fareFamily.minFreeCheckedBaggageQuantity }
                            }}
                          </div>
                        </ng-container>
                        <ng-container *ngIf="fareFamily.minFreeCheckedBaggageQuantity === 0">
                          <div class="c-available-list__item-icon">
                            <img src="assets/images/icon_feature_not_available_24.svg" width="24" height="24" />
                          </div>
                          <div class="c-available-list__item-title">
                            {{
                              'm_static_message-label.freeBaggagePcs'
                                | staticMsg : { '0': fareFamily.minFreeCheckedBaggageQuantity }
                            }}
                          </div>
                        </ng-container>
                      </li>
                      <!-- 最小無料預け入れ手荷物個数出し分け end -->
                      <!-- 座席指定料金出し分け start -->
                      <li class="c-available-list__item">
                        <ng-container *ngIf="fareFamily.fareFamilyWithService?.seat?.applicability === 'chargeable'">
                          <div class="c-available-list__item-icon">
                            <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
                          </div>
                          <div class="c-available-list__item-title">
                            {{ 'm_static_message-label.chargeableSeatAssign3' | staticMsg }}
                          </div>
                        </ng-container>
                        <ng-container *ngIf="fareFamily.fareFamilyWithService?.seat?.applicability === 'included'">
                          <div class="c-available-list__item-icon">
                            <img src="assets/images/icon_feature_available_24.svg" width="24" height="24" />
                          </div>
                          <div class="c-available-list__item-title">
                            {{ 'm_static_message-label.asrFree' | staticMsg }}
                          </div>
                        </ng-container>
                        <ng-container *ngIf="fareFamily.fareFamilyWithService?.seat?.applicability === 'notOffered'">
                          <div class="c-available-list__item-icon">
                            <img src="./assets/images/icon_feature_not_available_24.svg" width="24" height="24" />
                          </div>
                          <div class="c-available-list__item-title">
                            {{ 'm_static_message-label.asr.chargeableType.impossible' | staticMsg }}
                          </div>
                        </ng-container>
                      </li>
                      <!-- 座席指定料金出し分け end -->
                    </ul>
                  </div>
                </div>
                <!-- 選択ボタン出し分け start -->
                <div class="p-fare-panel02__footer">
                  <ng-container *ngIf="isSelect[fareFamilyIndex]; else notSelect">
                    <button
                      class="c-btn-primary c-btn-primary--s"
                      disabled=""
                      id="complex-flight-availability-changeFarePanel"
                      (throttleClick$)="changeFarePanel(fareFamilyIndex)"
                      aswThrottleClick
                    >
                      <span class="c-btn-primary__text">{{ 'm_static_message-label.selecting' | staticMsg }}</span>
                    </button>
                  </ng-container>
                  <ng-template #notSelect>
                    <button
                      class="c-btn-primary c-btn-primary--s"
                      id="complex-flight-availability-changeFarePanel2"
                      (throttleClick$)="changeFarePanel(fareFamilyIndex)"
                      aswThrottleClick
                    >
                      <span class="c-btn-primary__text">{{ 'm_static_message-label.selectRadio' | staticMsg }}</span>
                    </button>
                  </ng-template>
                </div>
                <!-- 選択ボタン出し分け end -->
              </ng-container>
            </div>
          </ng-container>
        </div>
        <!-- FF一覧表示処理 end -->
      </div>
    </div>
    <button
      id="fare-panel-scroll-right-btn"
      class="l-carousel01__arrow l-carousel01__arrow--next is-available"
      [attr.aria-label]="'alt.switchToRightScreen1' | staticMsg"
      *ngIf="isScrollRight"
      (throttleClick$)="this.scrollToRight()"
      aswThrottleClick
    >
      <img
        src="assets/images/btn_arrow_next_36.svg"
        width="36"
        height="36"
        alt="{{ 'alt.switchToRightScreen1' | staticMsg }}"
        aria-hidden="true"
      />
    </button>
  </asw-common-slider>
</div>
